import { Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { multiplyBorderRadius } from '@shared/theme/util';
import { Square } from '@/component/Grid';
import NoWrap from '@/component/Typography/NoWrap';
import { ConversationReferenceDto } from '@/feature/chatbot/api.types';
import { Icon } from '@/icon/Icon';
import { ReferenceCardImage } from './ReferenceCardImage';

const ReferencesGrid = styled('div', {
  name: 'Chatbot',
  slot: 'ReferencesGrid',
})(({ theme }) => ({
  display: 'grid',
  height: 'auto',
  width: 'auto',
  gridAutoFlow: 'row',
  gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
  gridGap: '16px',
  margin: theme.spacing(2),
  marginTop: 0,
  '&:last-child': {
    marginBottom: 0,
  },
}));

const ReferenceCard = styled(Paper, {
  name: 'Chatbot',
  slot: 'ReferenceCard',
})(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  borderRadius: multiplyBorderRadius(theme, 3),
  overflow: 'hidden',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
}));

const ReferenceHeader = styled('div', {
  name: 'Chatbot',
  slot: 'ReferenceHeader',
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5),
  width: '100%',
}));

const HeaderText = styled(Typography, {
  name: 'Chatbot',
  slot: 'ReferenceHeaderText',
})(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
}));

const ImageContainer = styled('div', {
  name: 'Chatbot',
  slot: 'ReferenceImageContainer',
})({
  position: 'relative',
  height: 'calc(100% - 42px)',
});

export const ReferenceCards = ({
  references,
}: {
  references?: ConversationReferenceDto[];
}) => {
  return (
    <ReferencesGrid>
      {references?.map((reference, i) => (
        <Square key={i} sx={{ paddingBottom: 'calc(141% + 42px)' }}>
          <ReferenceCard>
            <ReferenceHeader>
              <HeaderText>
                <Icon name="picture_as_pdf" size="xsmall" />
                <NoWrap>{reference.documentName}</NoWrap>
              </HeaderText>
            </ReferenceHeader>
            <ImageContainer>
              <ReferenceCardImage reference={reference} />
            </ImageContainer>
          </ReferenceCard>
        </Square>
      ))}
    </ReferencesGrid>
  );
};
